import type { DataAnalyticsId, ProjectState } from '@core/core/types'

import type { Prompt } from './types'

// Текущее состояние проекта -> О чём мы хотим спросить
// Если проект приватный, мы спрашиваем хотим ли мы его опубликовать
export const getModalContent = (
  state: ProjectState,
  projectName: string,
): Prompt & DataAnalyticsId => {
  if (state === 'Private') {
    return {
      prompt: (
        <>
          Вы действительно хотите опубликовать проект {projectName}?
          <br />
          Все участники Геомейта смогут просматривать и редактировать ваш проект.
        </>
      ),
      activeButtonText: 'Опубликовать',
      dataAnalyticsId: 'project_publication_done',
      newState: 'Public',
    }
  }

  return {
    prompt: (
      <>
        Хотите снять с публикации проект {projectName}?
        <br />
        Никто не сможет просматривать и редактировать ваш проект.
      </>
    ),
    activeButtonText: 'Снять с публикации',
    dataAnalyticsId: 'project_archive_done',
    newState: 'Private',
  }
}
